import { DeliveryDataD } from '@/components/drawer/extra-services/delivery-section/delivery-section.d'

export const DeliveryData: DeliveryDataD = {
  name: '',
  surname: '',
  country: '',
  building: '',
  contact_note: '',
  address: '',
  street_number: '',
  city: '',
  state: '',
  zipcode: '',
  province: '',
  reference_name: '',
  contact_email: '',
  contact_number: '',
}
